import Button from '../Button'
import Reveal from '../Reveal'
import { Section, SectionHead } from '../Section'

/** "Wie läuft eine Zusammenarbeit ab?" - shown on the home page and /verwalten.
    The four steps are the old site's, verbatim. */

const STEPS = [
  {
    title: 'Terminanfrage',
    text: 'Sie fragen ein kostenloses Erstgespräch an und machen ein paar Angaben zu Ihrem Objekt.',
  },
  {
    title: 'Bedarfsanalyse',
    text: 'Einer unserer Mitarbeiter spricht telefonisch mit Ihnen über Ihr Anliegen und vereinbart einen Vor-Ort-Termin.',
  },
  {
    title: 'Beratungsgespräch',
    text: 'Ein Berater trifft sich mit Ihnen an Ihrem Objekt und bespricht mit Ihnen die Rahmenbedingungen einer potenziellen Zusammenarbeit.',
  },
  {
    title: 'Langfristige Zusammenarbeit',
    text: 'Im Anschluss des Beratungsgesprächs besteht die Option auf eine maßgeschneiderte Partnerschaft.',
  },
]

export default function Process() {
  return (
    <Section tone="dark">
      <div className="blueprint" aria-hidden="true" />
      <SectionHead
        eyebrow="Wie läuft eine Zusammenarbeit ab?"
        title="Erhalten Sie einen Einblick in unsere Prozesse"
        lead="Vier Schritte vom ersten Kontakt bis zur Verwaltung. Bis zum Angebot entstehen Ihnen keine Kosten."
      />

      <Reveal group className="steps">
        {STEPS.map((step, index) => (
          <div className="step" key={step.title}>
            <span className="step__n">
              Schritt {String(index + 1).padStart(2, '0')}
            </span>
            <h3 className="step__title">{step.title}</h3>
            <p>{step.text}</p>
          </div>
        ))}
      </Reveal>

      <div className="btn-row" style={{ marginTop: 'var(--s-8)' }}>
        <Button to="/kontakt" icon="arrowRight">
          Erstgespräch anfragen
        </Button>
      </div>
    </Section>
  )
}
